export const FormValidasiImkp = {
  lokasiKerja: [(v) => !!String(v || "").trim() || "Lokasi harus diisi."],
  subLokasiKerja: [
    (v) =>
      (Array.isArray(v) ? v.length > 0 : !!String(v || "").trim()) ||
      "Sub lokasi harus diisi.",
  ],
  keteranganLokasiKerja: [
    (v) => !!String(v || "").trim() || "Keterangan lokasi harus diisi.",
  ],
  judulProyek: [(v) => !!String(v || "").trim() || "Judul proyek harus diisi."],
  mulaiPekerjaan: [
    (v) => !!String(v || "").trim() || "Mulai pekerjaan harus diisi.",
  ],
  selesaiPekerjaan: [
    (v) => !!String(v || "").trim() || "Selesai pekerjaan harus diisi.",
  ],
  uraianPekerjaan: [
    (v) => !!String(v || "").trim() || "Uraian pekerjaan harus diisi.",
    (v) => (v || "").length <= 1000 || "Maksimal 1000 karakter.",
    (v) => {
      const value = String(v ?? "").replace(/\r\n/g, "\n"); // normalisasi line ending
      const logicalLines = value
          .split("\n")
          .reduce(
              (count, line) => count + Math.max(1, Math.ceil(line.length / 115)),
              0
          );

      return (
          logicalLines <= 9 ||
          "Maksimal 9 baris (dengan panjang maksimal 115 karakter per baris)."
      );
    },
  ],
  tindakPencegahan: [
    (v) => !!String(v || "").trim() || "Tindak pecegahan lainnya harus diisi.",
    (v) => (v || "").length <= 650 || "Maksimal 650 karakter.",
    (v) => {
      const value = String(v ?? "").replace(/\r\n/g, "\n"); // normalisasi line ending
      const logicalLines = value
          .split("\n")
          .reduce(
              (count, line) => count + Math.max(1, Math.ceil(line.length / 115)),
              0
          );

      return (
          logicalLines <= 6 ||
          "Maksimal 6 baris (dengan panjang maksimal 115 karakter per baris)."
      );
    },
  ],
  filePersyaratanKhusus: [
    (v) => !!v?.length || "File harus diunggah.",
    (v) => {
      if (!v?.length) return true;
      const allowedTypes = ["application/pdf"];
      return (
          v.every((f) => allowedTypes.includes(f.type)) ||
          "Hanya file PDF yang diperbolehkan."
      );
    },
    (v) => {
      if (!v?.length) return true;
      const maxSize = 5 * 1024 * 1024; // 2MB
      return v.every((f) => f.size <= maxSize) || "Ukuran file maksimal 5MB.";
    },
  ],
  ttd: [
    (v) => !!v || "File harus diunggah",
    (v) => {
      if (!v?.length) return true;
      const allowedTypes = ["image/jpg", "image/jpeg", "image/png"];
      return (
          v.every((f) => allowedTypes.includes(f.type)) ||
          "Hanya file jpg, jpeg, dan png yang diperbolehkan."
      );
    },
    (v) => {
      if (!v?.length) return true;
      const maxSize = 5 * 1024 * 1024; // 2MB
      return v.every((f) => f.size <= maxSize) || "Ukuran file maksimal 5MB.";
    },
  ],
  namaDirekturUtama: [
    (v) => !!String(v || "").trim() || "Nama direktur utama harus diisi.",
  ],
  name: [(v) => !!String(v || "").trim() || "Nama harus diisi."],
  email: [
    (v) => !!String(v || "").trim() || "Email harus diisi.",
    (v) => /.+@.+\..+/.test(v) || "Format email tidak valid.",
  ],
  nomor: [
    (v) => !!String(v || "").trim() || "Nomor harus diisi.",
    (v) => /^\d+$/.test(v) || "Nomor hanya boleh berisi angka.",
  ],
};

export const FormValidasiGeneral = {
  name: [(v) => !!String(v || "").trim() || "Nama harus diisi."],
  email: [(v) => !!String(v || "").trim() || "Email harus diisi."],
  number: [(v) => !!String(v || "").trim() || "Nomor harus diisi."],
};
